import React, { useState, useEffect } from 'react';
import { t } from '../i18n';
import { useNavigate } from 'react-router-dom';

const BACKEND = '/api';

const PLAN_COLORS = {
  free: '#6b7280', starter: '#0F6E56', pro: '#3b82f6', unlimited: '#3b82f6'
};

export default function MySubscriptions() {
  const [purchases, setPurchases] = useState([]);
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [totalSpent, setTotalSpent] = useState(0);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      // Fetch purchases
      const r1 = await fetch(BACKEND + '/merchants/user/purchases/', {
        headers: { 'Authorization': 'Token ' + token }
      });
      const d1 = await r1.json();
      setPurchases(d1.purchases || []);
      setTotalSpent(d1.total_spent || 0);

      // Fetch merchant profile
      const r2 = await fetch(BACKEND + '/merchants/profile/', {
        headers: { 'Authorization': 'Token ' + token }
      });
      const d2 = await r2.json();
      if (!d2.error) setMerchant(d2);
    } catch(e) {}
    setLoading(false);
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#0a0e1a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: '#0F6E56' }}>{t('ms_loading')}</div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#0a0e1a', color: '#fff', fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
      <div style={{ background: '#1a1a2e', borderBottom: '1px solid #2a2a4a', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: '#0F6E56', cursor: 'pointer', fontSize: 14 }}>{t('ms_back')}</button>
        <h2 style={{ margin: 0, color: '#0F6E56' }}>{t('ms_title')}</h2>
      </div>

      <div style={{ maxWidth: 800, margin: '0 auto', padding: 20 }}>

        {/* Merchant Subscription */}
        {merchant && (
          <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 16, padding: 20, marginBottom: 20 }}>
            <h3 style={{ color: '#fff', margin: '0 0 16px' }}>{t('ms_sub')}</h3>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
              <div>
                <p style={{ color: '#aaa', margin: '0 0 4px', fontSize: 13 }}>{t('ms_business')}</p>
                <p style={{ color: '#fff', margin: 0, fontWeight: 'bold' }}>{merchant.business_name}</p>
              </div>
              <div>
                <p style={{ color: '#aaa', margin: '0 0 4px', fontSize: 13 }}>{t('ms_plan')}</p>
                <span style={{ background: PLAN_COLORS[merchant.plan] || '#6b7280', color: '#fff', padding: '4px 16px', borderRadius: 20, fontWeight: 'bold', textTransform: 'capitalize' }}>
                  {merchant.plan || 'free'}
                </span>
              </div>
              <div>
                <p style={{ color: '#aaa', margin: '0 0 4px', fontSize: 13 }}>{t('ms_expires')}</p>
                <p style={{ color: '#22c55e', margin: 0, fontWeight: 'bold' }}>{merchant.expires_at || 'N/A'}</p>
              </div>
              <button onClick={() => navigate('/merchant-tiers')}
                style={{ padding: '8px 20px', background: '#0F6E56', color: '#000', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 'bold' }}>
                Upgrade
              </button>
            </div>
          </div>
        )}

        {/* Summary */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>
          <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 12, padding: 16, textAlign: 'center' }}>
            <div style={{ color: '#0F6E56', fontSize: 28, fontWeight: 'bold' }}>{totalSpent} Pi</div>
            <div style={{ color: '#aaa', fontSize: 12 }}>{t('ms_spent')}</div>
          </div>
          <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 12, padding: 16, textAlign: 'center' }}>
            <div style={{ color: '#0F6E56', fontSize: 28, fontWeight: 'bold' }}>{purchases.length}</div>
            <div style={{ color: '#aaa', fontSize: 12 }}>{t('ms_tx')}</div>
          </div>
        </div>

        {/* Ledger */}
        <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 16, padding: 20 }}>
          <h3 style={{ color: '#fff', margin: '0 0 16px' }}>{t('ms_ledger')}</h3>
          {purchases.length === 0 ? (
            <p style={{ color: '#aaa', textAlign: 'center' }}>{t('ms_no_tx')}</p>
          ) : (
            <div>
              {/* Header */}
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1.5fr 1fr 1fr 1fr', gap: 6, padding: '8px 0', borderBottom: '1px solid #2a2a4a', marginBottom: 8 }}>
                <span style={{ color: '#aaa', fontSize: 12 }}>{t('ms_merchant')}</span>
                <span style={{ color: '#aaa', fontSize: 12 }}>{t('ms_date')}</span>
                <span style={{ color: '#aaa', fontSize: 12 }}>{t('ms_amount')}</span>
                <span style={{ color: '#aaa', fontSize: 12 }}>{t('ms_expires')}</span>
                <span style={{ color: '#aaa', fontSize: 12 }}>{t('ms_invoice')}</span>
              </div>
              {purchases.map((p, i) => (
                <div key={i} style={{ display: 'grid', gridTemplateColumns: '2fr 1.5fr 1fr 1fr 1fr', gap: 6, padding: '10px 0', borderBottom: '1px solid #2a2a4a', alignItems: 'center' }}>
                  <span style={{ color: '#fff', fontSize: 14, cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => navigate('/merchants/' + p.merchant_slug)}>
                    {p.merchant_name}
                  </span>
                  <span style={{ color: '#aaa', fontSize: 13 }}>{p.date}</span>
                  <span style={{ color: '#0F6E56', fontWeight: 'bold' }}>{p.pi_amount} Pi</span>
                  <span style={{ color: p.expires_in_days > 7 ? '#22c55e' : p.expires_in_days > 0 ? '#0F6E56' : '#ef4444', fontSize: 12 }}>
                    {p.expires_in_days !== null && p.expires_in_days !== undefined ? (p.expires_in_days > 0 ? p.expires_in_days + 'd left' : 'Expired') : 'N/A'}
                  </span>
                  <button onClick={() => setSelectedInvoice(p)}
                    style={{ padding: '4px 10px', background: '#0d1b2a', color: '#0F6E56', border: '1px solid #0F6E56', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>
                    Invoice
                  </button>
                </div>
              ))}
              {/* Total */}
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0 0', borderTop: '2px solid #2a2a4a', marginTop: 8 }}>
                <span style={{ color: '#fff', fontWeight: 'bold' }}>{t('ms_spent')}</span>
                <span style={{ color: '#0F6E56', fontWeight: 'bold', fontSize: 18 }}>{totalSpent} Pi</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Invoice Modal */}
      {selectedInvoice && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, maxWidth: 400, width: '100%', color: '#000' }}>
            <div style={{ textAlign: 'center', marginBottom: 20, borderBottom: '3px solid #0F6E56', paddingBottom: 16 }}>
              <h2 style={{ color: '#1a1a2e', margin: '0 0 4px' }}>XpertCreation</h2>
              <p style={{ color: '#666', margin: 0, fontSize: 12 }}>{t('ms_pay_inv')}</p>
            </div>
            <div style={{ marginBottom: 16 }}>
              {[
                { label: 'Merchant', value: selectedInvoice.merchant_name },
                { label: 'Description', value: selectedInvoice.memo || 'Merchant Payment' },
                { label: 'Amount Paid', value: selectedInvoice.pi_amount + ' Pi', color: '#0F6E56' },
                { label: 'Date', value: selectedInvoice.date },
                { label: 'Expires On', value: selectedInvoice.expires_at || 'N/A', color: '#22c55e' },
                { label: 'Days Remaining', value: selectedInvoice.expires_in_days !== null ? (selectedInvoice.expires_in_days > 0 ? selectedInvoice.expires_in_days + ' days' : 'Expired') : 'N/A', color: selectedInvoice.expires_in_days > 7 ? '#22c55e' : '#ef4444' },
              ].map((row, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
                  <span style={{ color: '#666', fontSize: 13 }}>{row.label}</span>
                  <span style={{ fontWeight: 'bold', fontSize: 13, color: row.color || '#000' }}>{row.value}</span>
                </div>
              ))}
              {selectedInvoice.txid && (
                <div style={{ marginTop: 12, padding: 10, background: '#f9fafb', borderRadius: 8, wordBreak: 'break-all' }}>
                  <p style={{ color: '#666', fontSize: 11, margin: 0 }}>{t('ms_txid')}</p>
                  <p style={{ color: '#333', fontSize: 11, margin: '4px 0 0', fontFamily: 'monospace' }}>{selectedInvoice.txid}</p>
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => setSelectedInvoice(null)}
                style={{ flex: 1, padding: 12, background: '#0F6E56', color: '#000', border: 'none', borderRadius: 8, fontWeight: 'bold', cursor: 'pointer' }}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
